import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'
import { FaArrowLeftLong, FaArrowRightLong } from 'react-icons/fa6'
import { customerHelper } from '@tweddle-se-team/common/constants'
import { customerId } from '@/utils/env'

const { CUSTOMER_IDS } = customerHelper

const directionalIconsByCustomer = {
  [CUSTOMER_IDS.TME]: {
    left: BsArrowLeft,
    right: BsArrowRight
  },
  [CUSTOMER_IDS.SUBARU]: {
    left: BsArrowLeft,
    right: BsArrowRight
  },
  [CUSTOMER_IDS.NORDICS]: {
    left: FaArrowLeftLong,
    right: FaArrowRightLong
  }
}

const DirectionalArrow = ({ direction = 'right', ...props }) => {
  const directionalIcons = directionalIconsByCustomer[customerId] || directionalIconsByCustomer[CUSTOMER_IDS.TME]
  const Icon = directionalIcons[direction] || directionalIcons.right

  return <Icon {...props} />
}

export default DirectionalArrow
